import { render, staticRenderFns } from "./footer-index.vue?vue&type=template&id=8f758d4e"
import script from "./footer-index.vue?vue&type=script&lang=js"
export * from "./footer-index.vue?vue&type=script&lang=js"
import style0 from "./footer-index.vue?vue&type=style&index=0&id=8f758d4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports